import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Stack,
} from '@mui/material';
import { Button, Checkbox, IconButton, Typography } from '@sweep-io/sweep-design';
import { useState } from 'react';
import { Close } from '@sweep-io/sweep-design/dist/icons';

export const EnrollExistingContactsDialog = ({
  onClose,
  onDeploy,
}: {
  onClose: () => void;
  onDeploy: (enrollExistingContacts: boolean) => void;
}) => {
  const [enrollExistingContacts, setEnrollExistingContacts] = useState(false);
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">Enroll existing contacts?</Typography>
          <IconButton onClick={onClose} variant="flat">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '532px' }}>
        <FormControlLabel
          label={
            <Typography variant="body">
              Yes, enroll contacts who already meet the criteria when the workflow starts.
            </Typography>
          }
          control={
            <Checkbox
              checked={enrollExistingContacts}
              onChange={() => setEnrollExistingContacts(true)}
            />
          }
        />
        <FormControlLabel
          label={
            <Typography variant="body">
              No, only enroll new contacts who meet the criteria after it starts.
            </Typography>
          }
          control={
            <Checkbox
              checked={!enrollExistingContacts}
              onChange={() => setEnrollExistingContacts(false)}
            />
          }
        />
      </DialogContent>
      <DialogActions>
        <Button size="medium" onClick={() => onDeploy(enrollExistingContacts)}>Deploy</Button>
      </DialogActions>
    </Dialog>
  );
};
